/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IDataLinkConfigurationScope extends angular.IScope {
        processConfigId: string;
        dataLinks: Wars.Domain.Model.DataLink[];

        addDataLink(): void;
        removeDataLink(dataLink: Wars.Domain.Model.DataLink): void;

        onItem1DragOver(dataLink: Wars.Domain.Model.DataLink, $event: any): void;
        onItem1Drop(dataLink: Wars.Domain.Model.DataLink, $event: any): void;

        onItem2DragOver(dataLink: Wars.Domain.Model.DataLink, $event: any): void;
        onItem2Drop(dataLink: Wars.Domain.Model.DataLink, $event: any): void;

        filterText: string;
        filterMethod(dataLink: Wars.Domain.Model.DataLink): boolean; 
    }

    export class DataLinkConfigurationController implements IController {
        private addIndex: number = 0;

        constructor(
            private $scope: IDataLinkConfigurationScope,
            $routeParams: angular.route.IRouteParamsService,
            private treeService: services.TreeService,
            private dataLinkService: services.DataLinkService)
        {
            this.$scope.processConfigId = $routeParams["id"];
            this.$scope.filterText = '';

            this.dataLinkService.getDataLinks(this.$scope.processConfigId).then(
                (dataLinks) => {
                    this.$scope.dataLinks = dataLinks;
                    this.$scope.dataLinks.forEach((dataLink) => {
                        if (dataLink.item1TreeItem_id !== null) {
                            this.treeService.getDetailedDisplayName(dataLink.item1TreeItem).then((name) => {
                                (<any>dataLink.item1TreeItem).detailedDisplay = name;
                                (<any>dataLink.item1TreeItem).orderHelper = "existing";
                            });
                        }
                        if (dataLink.item2TreeItem_id !== null) {
                            this.treeService.getDetailedDisplayName(dataLink.item2TreeItem).then((name) => {
                                (<any>dataLink.item2TreeItem).detailedDisplay = name;
                            });
                        }
                    });
                });

            this.$scope.addDataLink = () => this.addDataLink();
            this.$scope.removeDataLink = (dataLink: Wars.Domain.Model.DataLink) => this.removeDataLink(dataLink);

            this.$scope.onItem1DragOver = (dataLink: Wars.Domain.Model.DataLink, $event: any) => this.onItem1DragOver(dataLink, $event);
            this.$scope.onItem1Drop = (dataLink: Wars.Domain.Model.DataLink, $event: any) => this.onItem1Drop(dataLink, $event);
            this.$scope.onItem2DragOver = (dataLink: Wars.Domain.Model.DataLink, $event: any) => this.onItem2DragOver(dataLink, $event);
            this.$scope.onItem2Drop = (dataLink: Wars.Domain.Model.DataLink, $event: any) => this.onItem2Drop(dataLink, $event);
            this.$scope.filterMethod = (dataLink: Wars.Domain.Model.DataLink) =>
            {
                var lowerCaseFilterText = this.$scope.filterText.toLowerCase();
                return (
                    dataLink.item1TreeItem === undefined ||
                    dataLink.item1TreeItem === null ||
                    (<any>dataLink.item1TreeItem).detailedDisplay === undefined ||
                    (<any>dataLink.item1TreeItem).detailedDisplay.toLowerCase().indexOf(lowerCaseFilterText) !== -1
                )
                    ||
                (
                    dataLink.item2TreeItem === undefined ||
                    dataLink.item2TreeItem === null ||
                    (<any>dataLink.item2TreeItem).detailedDisplay == null ||
                    (<any>dataLink.item2TreeItem).detailedDisplay.toLowerCase().indexOf(lowerCaseFilterText) !== -1);
            };
        }

        private addDataLink() : void {
            var newDataLink = this.dataLinkService.createNewDataLink(this.$scope.processConfigId);
            this.$scope.dataLinks.push(newDataLink);
            this.dataLinkService.saveAllChanges();
            this.addIndex++;
        }

        private removeDataLink(dataLink: Wars.Domain.Model.DataLink): void {
            // Nothing should reference data links, if this changes stop the manual delete and use the delete service
            if (dataLink.item1TreeItem) {
                dataLink.item1TreeItem.entityAspect.setDeleted();
            }
            if (dataLink.item2TreeItem) {
                dataLink.item2TreeItem.entityAspect.setDeleted();
            }
            dataLink.entityAspect.setDeleted();
            this.dataLinkService.saveAllChanges();
            this.$scope.dataLinks.remove(dataLink);
        }

        private onItem1DragOver(dataLink: Wars.Domain.Model.DataLink, $event: any): void {

        }

        private onItem1Drop(dataLink: Wars.Domain.Model.DataLink, $event: any): void {
            var treeItem = this.treeService.createTreeItemFromItemDropped();
            dataLink.item1TreeItem = treeItem;

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();

            this.dataLinkService.saveAllChanges(() => {
                    if (dataLink.item1TreeItem_id !== null) {
                        this.treeService.getDetailedDisplayName(dataLink.item1TreeItem).then((name) => {
                            (<any>dataLink.item1TreeItem).detailedDisplay = name;
                            (<any>dataLink.item1TreeItem).orderHelper = "new" + this.addIndex;
                        });
                    }
                }
            );
        }

        private onItem2DragOver(dataLink: Wars.Domain.Model.DataLink, $event: any): void {

        }

        private onItem2Drop(dataLink: Wars.Domain.Model.DataLink, $event: any): void {
            var treeItem = this.treeService.createTreeItemFromItemDropped();
            dataLink.item2TreeItem = treeItem;

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();

            this.dataLinkService.saveAllChanges(() => {
                if (dataLink.item2TreeItem_id !== null) {
                    this.treeService.getDetailedDisplayName(dataLink.item2TreeItem).then((name) => {
                        (<any>dataLink.item2TreeItem).detailedDisplay = name;
                    });
                }
            });
        }
    }
}

warsApp.registerController('DataLinkConfigurationController', ['$scope', '$routeParams', 'treeService', 'dataLinkService']);